import { Token } from "@typings/token"

export const getTokens = async (authToken: string): Promise<Token[]> => {
  try {
    const response = await fetch(
      `${import.meta.env.VITE_CORE_API_URL}/tokens/all`,
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      }
    )

    if (!response.ok)
      throw new Error(`Error: ${response.status} ${response.statusText}`)

    const data = await response.json()

    const tokens: Token[] = data.data
    return tokens
  } catch (error) {
    console.error("Failed to fetch tokens:", error)
    throw error
  }
}
